import i18n from '@/lang/i18n'
import { Nullable } from '@/shared/types/app.types'
import { DefaultComboOption } from '@/modules/RegistryModule/views/editCase/modals/reports-modal-form/reports-modal.model'
import { EnumResponse } from '@/api/services/common.dto'

export enum FilterByAnaReportEnum {
    PATHOLOGIST = 'pathologist.id',
    REQUESTING_CENTER = 'physicianDepartment.center.id',
    REQUESTING_DEPARTMENT = 'physicianDepartment.id',
    REQUESTING_PROFESSIONAL = 'physicianPetitioner.id',
    DESTINATION_CENTER = 'destinationDepartment.center.id',
    DESTINATION_DEPARTMENT = 'destinationDepartment.id',
    DESTINATION_PROFESSIONAL = 'casAttn',
    REGIME = 'regime.id',
    PRIORITY = 'priority.id'
}

export enum ShowByEnum {
    // ALPHABETICAL = 'casCasenumber,asc',
    ASCENDING = 'casCasenumber,asc',
    DESCENDING = 'casCasenumber,desc'
}

export const filterByOptions: DefaultComboOption[] = [
    { id: FilterByAnaReportEnum.PATHOLOGIST, label: i18n.tc('registry.modal.reports.filterBy.pathologist') },
    { id: FilterByAnaReportEnum.REQUESTING_CENTER, label: i18n.tc('registry.modal.reports.filterBy.requestingCenter') },
    { id: FilterByAnaReportEnum.REQUESTING_DEPARTMENT, label: i18n.tc('registry.modal.reports.filterBy.requestingDepartment') },
    { id: FilterByAnaReportEnum.REQUESTING_PROFESSIONAL, label: i18n.tc('registry.modal.reports.filterBy.requestingProfessional') },
    { id: FilterByAnaReportEnum.DESTINATION_CENTER, label: i18n.tc('registry.modal.reports.filterBy.destinationCenter') },
    { id: FilterByAnaReportEnum.DESTINATION_DEPARTMENT, label: i18n.tc('registry.modal.reports.filterBy.destinationDepartment') },
    { id: FilterByAnaReportEnum.DESTINATION_PROFESSIONAL, label: i18n.tc('registry.modal.reports.filterBy.destinationProfessional') },
    { id: FilterByAnaReportEnum.REGIME, label: i18n.tc('registry.modal.reports.filterBy.regime') },
    { id: FilterByAnaReportEnum.PRIORITY, label: i18n.tc('registry.modal.reports.filterBy.priority') }
]

export const showByOptions: DefaultComboOption[] = [
    // { id: ShowByEnum.ALPHABETICAL, label: i18n.tc('registry.modal.reports.alphabeticalOrder') },
    { id: ShowByEnum.ASCENDING, label: i18n.tc('registry.modal.reports.ascendingNumber') },
    { id: ShowByEnum.DESCENDING, label: i18n.tc('registry.modal.reports.descendingNumber') }
]

export enum filterTypes {
    SET = 'set',
    EQUALS = 'equals',
    DATE = 'date',
    TEXT = 'text'
}

export interface SetFilter {
    filterType?: filterTypes.SET,
    values?: any[]
}

export interface ReportModalFormContentFilter extends SetFilter{
    id: string,
    value?: string
}

export interface ReportsModalFormContentFilterState {
    caseStatus: Nullable<EnumResponse>,
    showBy: Nullable<DefaultComboOption>
    filterBy: Nullable<DefaultComboOption>,
    filters: ReportModalFormContentFilter[],
    comboOptions: {
        filterByOptions: DefaultComboOption[]
        showByOptions: DefaultComboOption[]
    }
}
export const initialReportsModalFormContentFilter =
    (): ReportsModalFormContentFilterState => ({
        caseStatus: null,
        showBy: null,
        filterBy: null,
        filters: [],
        comboOptions: {
            filterByOptions: filterByOptions,
            showByOptions: showByOptions
        }
    })
